export default "__VITE_ASSET__CQL_AavV__"